/*
* Logout
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Auth from '../auth/auth';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { AuthConfig } from '../config/authconfiguration';
import AppConfiguration from '../config/configuration';
import * as ReduxQueries from '../queries';

class AppLogout extends AppComp.AppComponentNoWrapper<AppComp.IAppComponentProps, any> {
  public constructor(props: any) {
    super(props, 'app.root-home.');
  }

  public render() {
    const { branding, ...rest } = this.props;
    
    const authConfig = AppConfiguration.getAuth0Configuration();
    const auth = new Auth();
    auth.setLocalStorageValue(AuthConfig.LocalStorageTokens.loggedOutAt, '');

    // console.log(`logout authConfig.logoutRedirectTo ${_.get(authConfig, 'logoutRedirectTo', '')} authConfig.redirectUri ${_.get(authConfig, 'redirectUri', '')}`, {authConfig});

    return (
      <div>
        <Row><Col xs={12}>&nbsp;</Col></Row>
        <Row>
          <Col xs={4} xsOffset={4}>
            {/* Branded app logo */}
            <Row>
              <Col xs={12}>
                <img src={branding.logo.login} />
              </Col>
            </Row>
            <Row>&nbsp;</Row>            
            <Row>
              <div />
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state: AppComp.IAppComponentState, props): AppComp.IAppComponentProps =>
  ReduxQueries.MapQueryStateToPropsRoot(state, props, null);
export default withRouter<AppComp.IAppComponentProps>(connect(mapStateToProps, {})(AppLogout));



// WEBPACK FOOTER //
// ./src/app-root-home/logout.tsx